/**
 * Floating Action Button (FAB) Global
 * 
 * Botão flutuante que aparece em todas as páginas e permite
 * acessar ações rápidas: Sessões Ativas e Enviar Mensagem/Email
 * 
 * @author Equipe GestaoeCRM
 * @date 06/11/2025
 */

import React, { useState } from 'react';
import { Activity, MessageSquare, X } from 'lucide-react';
import GlobalActionModal from './GlobalActionModal';

/**
 * Componente FloatingActionButton
 * 
 * Botão flutuante fixo no canto inferior direito da tela
 * que abre um modal com opções de ações rápidas
 */
const FloatingActionButton: React.FC = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <>
      {/* Botão Flutuante */}
      <button
        onClick={() => setIsModalOpen(true)}
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-gradient-to-r from-primary to-secondary hover:brightness-110 text-white rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center justify-center group"
        title="Ações Rápidas"
        aria-label="Abrir ações rápidas"
      >
        {isModalOpen ? (
          <X className="w-6 h-6 transition-transform duration-300" />
        ) : (
          <Activity className="w-6 h-6 transition-transform duration-300 group-hover:scale-110" />
        )}
      </button>

      {/* Modal Global de Ações */}
      <GlobalActionModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </>
  );
};

export default FloatingActionButton;

